import axiosClient from "../axios/axiosClient";

export function getTitles() {
  return axiosClient.get("/titles");
}

export function getTitle(titleId) {
  return axiosClient.get(`/titles/${titleId}`);
}

export function createTitle(data) {
  return axiosClient.post("/titles", data);
}

export const updateTitle = (titleId, data) => {
  return axiosClient.put(`/titles/${titleId}`, data);
};

export function deleteTitle(titleId) {
  return axiosClient.delete(`/titles/${titleId}`);
}
